/* CE:ATELIER_ORDER - aligne l ordre des comparateurs FR sur la reference EN */
(function(){
  if(location.pathname.indexOf("/pages/restoration")<0)return;
  var REF=["restoration-ba-before5","restoration-ba-before4","restoration-ba-before3","restoration-ba-before2","restoration-ba-before6","restoration-ba-before."];
  function rang(card){
    var im=card.getElementsByTagName("img");
    for(var k=0;k<im.length;k++){
      var s=im[k].getAttribute("src")||"";
      for(var i=0;i<REF.length;i++){ if(s.indexOf(REF[i])>-1) return i; }
    }
    return 999;
  }
  function trier(){
    var grilles=document.querySelectorAll(".ba-grid");
    if(!grilles.length)return false;
    var fait=false;
    for(var g=0;g<grilles.length;g++){
      var gr=grilles[g];
      var cards=[];
      var enfants=gr.children;
      for(var i=0;i<enfants.length;i++){ if(enfants[i].className&&(" "+enfants[i].className+" ").indexOf(" ba-card ")>-1) cards.push(enfants[i]); }
      if(cards.length<2)continue;
      var avant=cards.map(rang).join(",");
      var tries=cards.slice().sort(function(a,b){return rang(a)-rang(b);});
      var apres=tries.map(rang).join(",");
      if(avant===apres)continue;
      for(var j=0;j<tries.length;j++){ gr.appendChild(tries[j]); }
      fait=true;
    }
    return true;
  }
  trier();
  var n=0,iv=setInterval(function(){ trier(); if(++n>50) clearInterval(iv); },300);
})();